export default __webpack_public_path__ + "static/media/file-pdf-2.b56a7df9.svg";